//src/context/AuthContext

import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';  // Corrected import for jwt-decode
import Cookies from 'js-cookie';  // Import the js-cookie library
import ClientService from '../services/ClientService';
import { toast } from 'react-toastify';
import ProjectService from '../services/ProjectService';
import TicketService from '../services/TicketService';
import BillingItemsService from '../services/BillingItemsService';
import EmployeeService from '../services/EmployeeService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // *********** Login User ***********
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // To show loading until we verify the token

  // ***************** Client *****************
  const [clients, setClients] = useState([]);
  const [clientLoading, setClientLoading] = useState(false);
  const [clientError, setClientError] = useState(null);

  // ***************** Projects *****************

  const [projects, setProjects] = useState([]);
  const [projectLoading, setProjectsLoading] = useState(false);
  const [projectError, setProjectsError] = useState(null);

  // ***************** Tickets *****************
  const [tickets, setTickets] = useState([]); // State to hold fetched tickets
  const [ticketLoading, setTicketsLoading] = useState(false);
  const [ticketError, setTicketsError] = useState(null);

  // ***************** Bill *****************
  const [bills, setBills] = useState([]); // State to hold fetched tickets
  const [billsLoading, setBillsLoading] = useState(false);
  const [billsError, setBillsError] = useState(null);


    // ***************** Employee *****************
  const [employees, setEmployees] = useState([]); // State to hold fetched tickets
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [employeesError, setEmployeesError] = useState(null);


  // Check for token and user data in cookies when the component mounts
  useEffect(() => {
    const token = Cookies.get('token');
    const storedUser = Cookies.get('user');

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds

        // Check if token is expired
        if (decodedToken.exp < currentTime) {
          logout(); // Token is expired, log out the user
        }
        else {
          setUser(decodedToken);  // Set user info from the decoded token
        }
      } catch (error) {
        console.error("Invalid token", error);
        logout(); // Logout in case of invalid token
      }
    }

    setLoading(false); // Set loading to false after the check is complete
  }, []);

  // ***************** Login *****************

  const login = (token) => {
    Cookies.set('token', token, { expires: 7 });  // Set the token in cookies with an expiration of 7 days

    try {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      setUser(decodedToken)
      console.log(decodedToken)
    } catch (error) {
      console.error("Invalid token provided during login", error);
    }
  };


  // ***************** Logout *****************
  const logout = () => {
    Cookies.remove('token');  // Remove the token from cookies
    setUser(null);
  };

  // ***************** Client *****************
  const getClients = async () => {
    setClientLoading(true);
    setClientError(null); // Reset error state
    try {
      const data = await ClientService.getAllClients(); // Call the API function
      setClients(data);
      console.log("Client Data: ", data)
    } catch (errorMessage) {
      setClientError(errorMessage); // Update error state
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "dark",
      });
    } finally {
      setClientLoading(false); // Reset loading state
    }
  };


  //********* Projects ************ */
  // Fetch all projects
  const getProjects = async () => {
    try {
      setProjectsLoading(true);
      const data = await ProjectService.getAllProjects();
      setProjects(data);
      console.log("data: ", data);
      setProjectsError(null);
    } catch (err) {
      setProjectsError("Failed to load projects. Please try again later.");
      console.error("Error fetching projects:", err);
    } finally {
      setProjectsLoading(false);
    }
  };

  //****************Tickts*******************
  const getTickets = async () => {
    setTicketsLoading(true);
    try {
      const data = await TicketService.getAllTickets(); // Fetch tickets from API
      console.log("Ticket Data: ", data);
      setTickets(data.tickets); // Set tickets to state
    } catch (err) {
      console.error("Error fetching ticket:", err);
      setTicketsError("Failed to load tickets. Please try again.");
    } finally {
      setTicketsLoading(false);
    }
  };


  // **************** Fetch Bill ****************

  const getAllBills = async () => {
    try {
      setBillsLoading(true);
      const mainBill = await BillingItemsService.getAllBillingItems();
      setBills(mainBill);
      console.log("Billing Details:", mainBill);
      setBillsLoading(false);
    }
    catch (err) {
      console.error("Error fetching billing details:", err);
      setBillsError("Failed to load billing information.");
      setBillsLoading(false);
    }
  };

  // **************** Fetch Employee ****************

  const getEmployees = async () => {
    try {
      setEmployeesLoading(true);
      const data = await EmployeeService.getAllEmployees();
      setEmployees(data);
      console.log("Employee Details:", data);
      setEmployeesLoading(false);
    }
    catch (err) {
      console.error("Error fetching employees details:", err);
      setEmployeesError("Failed to load employees information.");
      setEmployeesLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Render a loading state until token is checked
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,

        getClients,
        clients,
        clientLoading,
        clientError,


        getProjects, projects, setProjects, projectLoading,

        getTickets, setTickets, tickets, ticketLoading, ticketError,

        getAllBills, bills, setBills, billsLoading, billsError,

        getEmployees, employees, setEmployees, employeesLoading, employeesError, 

      }}>
      {children}
    </AuthContext.Provider>
  );
};
